import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import Button from "components/CustomButtons/Button.js";
import Tooltip from "@mui/material/Tooltip";
import Add from "@mui/icons-material/Add";
import TribalismProcess from "pages-sections/services/seo-services/TribalismProcess.js";


import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';


import styles from "../ServicesSections.module.scss";
export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  return (
    <div className={classes.section} >

<GridContainer justifyContent="center">
     
      
      <GridItem xs={12} sm={10} md={10} lg={8}  className={classes.section}   style = {{ paddingBottom : "80px",  }} >
          
      <h3 className={classes.title}>Why Us?</h3>
		
      <p>
				✅ We optimise for conversions, not just clicks <br />  
				✅ Quality Over Quantity - We only work with a limited number of clients at a time, we're not an agency that tries to get as many clients as possible.<br />
				✅ Speedy Response Time<br />    
				✅ 9+ Years of Experience in PPC / Adwords<br /></p>

      </GridItem> 

      </GridContainer>
    </div>
  );
}